"use client";

import AnswerCarouselBlock from "~/components/blocks/AnswerCarouselBlock";
import Container from "~/componentsDS/Layout/Container";
import Paragraph from "~/componentsDS/Typography/Paragraph";
import Heading from "~/componentsDS/Typography/Heading";
import Reveal from "~/componentsDS/Reveal";
import { AnswerItem } from "~/componentsDS/Answer";
import { cn } from "~/lib/utils";

type Props = {
    className?: string;
    answerItems: AnswerItem[];
    widget?: string;
}

const MeetDrSarahSection = ({ answerItems, widget, className }: Props) => {
    return (
        <section className={cn("pt-8 md:pt-[96px] md:pb-[50px] overflow-hidden", className)}>
            <Container className="lg:flex">
                <div className="lg:w-[565px] shrink-0 bg-pureWhite z-[1] lg:pr-12 lg:shadow-[-400px_0_0_400px_#fff]">
                    <div className="lg:w-[376px]">
                        <Reveal>
                            <Heading size="sm" sizes={{ lg: "md" }} className="mb-4 text-primary500 max-lg:max-w-[300px]">
                                Real guidance from the <br />
                                doctor behind Oestra<sup>®</sup>
                            </Heading>
                        </Reveal>

                        <Paragraph className="text-primary500 mb-6" size="lg">Dr. Sarah created Inner Balance to deliver a different kind of hormonal care.</Paragraph>
                        <Paragraph className="text-primary500" size="lg">Her approach centers on bioidentical hormone enrichment, safe delivery methods, and treatment guided by how women actually feel - not just lab numbers.</Paragraph>
                    </div>
                </div>

                <AnswerCarouselBlock
                    answerItems={answerItems}
                    className="lg:w-1/2 flex-grow max-lg:mt-8"
                    widget={widget}
                />
            </Container>
        </section>
    );
};

export default MeetDrSarahSection;
